/**
 * Daily Rate — Interação da régua de cotas
 * Clique nos dots para ativar e destacar a cota selecionada.
 */

export function initDailyRate() {
	const containers = document.querySelectorAll('[data-daily-rate]');
	if ( ! containers.length ) return;

	containers.forEach( container => {
		const dots = container.querySelectorAll('.daily-rate__dot');
		const labels = container.querySelectorAll('.daily-rate__label');

		if ( ! dots.length ) return;

		dots.forEach( dot => {
			dot.addEventListener('click', () => {
				const index = dot.getAttribute('data-index');

				// Remove active de todos
				dots.forEach( d => d.classList.remove('is-active') );
				labels.forEach( l => l.classList.remove('is-active') );

				// Ativa o clicado
				dot.classList.add('is-active');
				const label = container.querySelector(`.daily-rate__label[data-index="${index}"]`);
				if ( label ) label.classList.add('is-active');
			});
		});
	});
}
